<template>
  <transition name="fadeIn">
    <div v-show="!showPreloader" class="home">
      <div class="contentWrapper blurred">
        <Top />
        <AboutProject />
        <Opportunities />
        <Description />
        <Offers />
        <Organisator />
        <Contacts />
      </div>
      <transition name="popup-fade">
        <PopupOffer v-if="showPopup" :content="offers" :is-offer="true" />
      </transition>
      <transition name="popup-fade">
        <PopupOffer
          v-if="showTimetablePopup"
          :content="timetable"
          :is-offer="false"
        />
      </transition>
      <FormLoader v-if="showFormLoader" />
    </div>
  </transition>
</template>

<script>
import Top from './components/Top/Top.vue';
import Offers from './components/Offers/Offers.vue';
import Opportunities from './components/Opportunities/Opportunities.vue';
import Description from './components/Description/Description.vue';
import Organisator from './components/Organisator/Organisator.vue';
import Contacts from './components/Contacts/Contacts.vue';
import PopupOffer from './components/PopupOffer/PopupOffer.vue';
import FormLoader from './components/FormLoader/FormLoader.vue';
import { mapState } from 'vuex';
import AboutProject from '@/containers/Partnership/components/AboutProject/AboutProgect.vue';

export default {
  name: 'Partnersip',
  components: {
    AboutProject,
    Top,
    Offers,
    Opportunities,
    Description,
    Organisator,
    Contacts,
    PopupOffer,
    FormLoader
  },
  data() {
    return {
      offers: [
        {
          title: 'Логотип на сайті проєкту',
          text: 'Розміщення логотипу та інформації про діяльність вашої компанії на сайті проєкту.'
        },
        {
          title: 'Відеорозповідь про офіс компанії в соцмережах BEST Lviv',
          text: 'Неформальна відеорозповідь про офіс вашої компанії в Instagram stories @best_lviv та у TikTok-профілі @best__lviv, створена організаторами проєкту.'
        },
        {
          title: 'День інтерактивних stories',
          text: 'Промоція вашої компанії в Instagram-stories сторінки @best_lviv, використовуючи рубрики “Питання-відповідь”, “Як проходить день нашого працівника” тощо (1 рубрика на вибір). Контент для stories може створюватися вами чи організаторами проєкту (до 5 stories про партнера).'
        },
        {
          title:
            'Згадка компанії в дописі про партнерів у Instagram-профілі @best_lviv',
          text: 'Згадка компанії в дописі (на одному з креативів каруселі та в описі) у Instagram-профілі @best_lviv'
        },
        {
          title: 'Пост про компанію в telegram-каналі BEST Lviv Students',
          text: 'Пост про компанію-партнера з посиланням на її сайт та соцмережі у telegram-каналі BEST Lviv Students (@bestlviv).'
        }
      ],
      timetable: [
        { title: 'Екскурсія', text: 'Огляд офісу компанії учасниками події' },
        {
          title: 'Workshop',
          text: 'Навчальна лекція, тривалістю 30-60 хвилин на будь-яку тему: опис процесів компанії, вдосконалення гнучких навичок, кар’єрні можливості у вашій компанії тощо.'
        },
        {
          title: 'Speed datings',
          text: 'Короткий діалог між представниками вашої компанії та учасниками. Його мета — знайомство сторін, неформальне обговорення деталей діяльності компанії, інших тем, пов’язаних з вашою галуззю.'
        },
        {
          title: 'Панельна дискусія',
          text: 'Обговорення між представниками компанії та студентами-учасниками на теми, дотичні до галузей роботи компанії.'
        },
        {
          title: 'Розіграш',
          text: 'Проведення розіграшу призів від компанії для учасників на основі вікторин, завдань тощо.'
        }
      ]
    };
  },
  computed: mapState([
    'showPopup',
    'showTimetablePopup',
    'showFormLoader',
    'showResult',
    'showPreloader'
  ])
};
</script>

<style lang="scss" scoped>
.home {
  background: no-repeat;
  -moz-background-size: 100%;
  -webkit-background-size: 100%;
  -o-background-size: 100%;
  background-size: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  // TD: change gradient
  background-image: url('../../assets/images/bgGradient.svg');
  background-color: #ffffff;
}

.contentWrapper {
  display: flex;
  max-width: 1440px;
  flex-direction: column;
  align-items: center;
  gap: 13.889rem;
  padding: 0 12.431rem;
}

// TD: change accroding to popup
.blurred.active {
  filter: blur(1px);
  -webkit-filter: blur(1px);
}

@media screen and (max-width: 768px) {
  .home {
    width: 100%;
    background-image: url('../../assets/images/bgGradientMobile.svg');
    // TD: add gradinent
  }

  .contentWrapper {
    padding: 0 3.125rem;
    width: 100%;
    gap: 22.5rem;
  }
}
</style>
<style scoped>
@keyframes fadeIn {
  0% {
    opacity: 0;
    transition: all 0.2s ease-in-out;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}

.popup-fade-enter-active {
  animation: fadeIn 0.5s;
}

.popup-fade-leave-active {
  animation: fadeOut 0.5s;
}
</style>
